export default {
  methods: {
    updateStores(vuex, uuid, response) {
      response.data.uuid = uuid
      if (vuex.dispatch) {
        this.$store.dispatch(`${vuex.store}/${vuex.action}`, response.data)
      } else {
        this.$store.commit(`${vuex.store}/${vuex.mutations}`, response.data)
      }
    },
  },
}
